import React, { Suspense } from 'react';
import { Provider } from 'react-redux';
import { render } from 'react-dom';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { ScrollToTop, ErrorBoundary, TeleScript, getCMSObject } from 'sg-ui-components';

import { createStore } from './Store';

import HomePage from './pages/home';
import PromotionsPage from './pages/promotions';
import PromotionDetailsPage from './pages/promotionDetails';
import SecondChancePromotionPage from './pages/secondChancePromotion';
import LotteryPromotionDetailsPage from './pages/lotteryPromotionDetails';
import FeedbackPage from './pages/feedback';
import TermsPage from './pages/terms';
import PrivacyPage from './pages/privacy';

import EnterPage from './pages/enter';
import PostClaimPage from './pages/postClaim';
import MyActivityPage from './pages/myActivity';
import MyProfilePage from './pages/myProfile';
import ReferAFriendPage from './pages/referAFriend';
import SurveyPage from './pages/survey';
import LoginPage from './pages/login';
import ForgotPasswordPage from './pages/forgotPassword';
import RecoverPasswordPage from './pages/recoverPassword';
import PasswordExpiringPage from './pages/passwordExpiring';
import PasswordExpiredPage from './pages/passwordExpired';
import RegisterPage from './pages/register';
import RegisterVerificationErrorPage from './pages/registerVerificationError';
import AccountConfirmPage from './pages/accountConfirm';
import AwaitAccountConfirmationPage from './pages/awaitAccountConfirmation';
import LogoutPage from './pages/logout';
import UpdatePasswordPage from './pages/updatePassword';
import FaqPage from './pages/faq';
import RulesPage from './pages/rules';
import ContactUsPage from './pages/contactUs';


import PageNotFound from './pages/404';

import './styling/global.scss';
import PointsForDrawingsDetailsPage from './pages/pointsForDrawingsDetailsPage';
import Drawings from './pages/drawings';

const app = document.getElementById('root');

const errorBoundaryTelescript = getCMSObject('data.messages.pageErrorMessages.jsonBlock');

render(
    <Provider store={createStore()}>
        <ErrorBoundary fallback={<TeleScript line={errorBoundaryTelescript?.rootFallback} />} details={{}}>
            <Router basename='/'>
                <ScrollToTop />
                <Suspense fallback={<div>Loading...</div>}>
                    <Switch>
                        <Route exact path='/' component={HomePage} />
                        <Route path='/home' component={HomePage} />
                        <Route path='/promotions' component={PromotionsPage} />
                        <Route path='/drawings' component={Drawings} />
                        <Route path='/points-for-drawing-details/:sweepId' component={PointsForDrawingsDetailsPage} />
                        <Route path='/second-chance-promotion' component={SecondChancePromotionPage} />
                        <Route path='/promotion' component={PromotionDetailsPage} />
                        <Route path='/lottery-promotion' component={LotteryPromotionDetailsPage} />
                        <Route path='/login' component={LoginPage} />
                        <Route path='/forgot-password' component={ForgotPasswordPage} />
                        <Route path='/recover-password' component={RecoverPasswordPage} />
                        <Route path='/password-expiring' component={PasswordExpiringPage} />
                        <Route path='/password-expired' component={PasswordExpiredPage} />
                        <Route path='/update-password' component={UpdatePasswordPage} />
                        <Route path='/account-confirm' component={AccountConfirmPage} />
                        <Route path='/await-account-confirmation' component={AwaitAccountConfirmationPage} />

                        <Route path='/register' component={RegisterPage} />
                        <Route path='/register-verification-error' component={RegisterVerificationErrorPage} />
                        <Route path='/logout' component={LogoutPage} />

                        <Route path='/enter' component={EnterPage} />
                        <Route path='/post-claim' component={PostClaimPage} />

                        <Route path='/my-profile' component={MyProfilePage} />
                        <Route path='/my-activity' component={MyActivityPage} />
                        <Route path='/survey' component={SurveyPage} />
                        <Route path='/refer-a-friend' component={ReferAFriendPage} />

                        <Route path='/feedback' component={FeedbackPage} />

                        <Route path='/terms' component={TermsPage} />
                        <Route path='/privacy' component={PrivacyPage} />
                        <Route path='/faq' component={FaqPage} />
                        <Route path='/rules' component={RulesPage} />
                        <Route path='/contact-us' component={ContactUsPage} />

                        {/*
                        '/details' was the old route for '/promotion'
                        We preserved to prevent old links breaking. Please remove if not needed anymore.
                    */}
                        <Route path='/details' component={PromotionDetailsPage} />

                        <Route path='*' component={PageNotFound} />
                    </Switch>
                </Suspense>
            </Router>
        </ErrorBoundary>
    </Provider>,
    app
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker.unregister();
